import Cookies from 'js-cookie';

import {
  BOOK_QUERY_SUCCESS,
} from '../constants/actions';
import { forgetLinkID } from '../utils/crmLink';

// The cookie this module used to write (MS-6621, T4.7).
//
// It held the raw `book_*` parameters of a legacy Salesforce link — the buyer's name, mobile and
// email — for a day, across tabs, readable by anything on the domain. Those parameters are now
// posted once to `POST /crm/links/` and only the returned session id is kept, per tab. The name
// survives here for one reason: to delete any cookie a browser is still carrying from before this
// shipped, so the buyer's details in it do not sit there until they expire on their own.
const LEGACY_COOKIE = 'mhub-book-web-book-queries';

function bookQuerySuccess(data) {
  return {
    type: BOOK_QUERY_SUCCESS,
    payload: {
      data,
    },
  };
}

// clearBookQuery is called once a booking has been submitted. The link session is consumed
// server-side by that submit, so all that is left here is to stop pointing at it.
export function clearBookQuery() {
  return async (dispatch) => {
    Cookies.remove(LEGACY_COOKIE);
    forgetLinkID();
    await dispatch(bookQuerySuccess([]));
  };
}

// extractBookQuery clears what the old cookie-based arrival left behind.
//
// It used to build the `book_*` cookie. It no longer creates the link session either: that moved
// to the booking form, which is the only thing that consumes one. Two reasons.
//
// Creating it here raced the form. This runs inside BookApp's boot, which does not block
// rendering, so the form could mount, find no id, and give up — and then submit would pick the id
// up once it finally landed, attaching a session whose buyer details the salesperson was never
// shown.
//
// And an id left in the tab by an earlier arrival outlived a failure here. If buyer B's link was
// posted and the request failed, buyer A's id was still in sessionStorage and B's booking would
// consume A's session. Forgetting it up front means a failed exchange leaves nothing to pick up
// by mistake.
export function extractBookQuery() {
  return async (dispatch) => {
    // Nothing about the buyer is kept in redux any more. The reducer stays because other code
    // reads its shape, and emptying it explicitly clears anything an earlier arrival left behind.
    await dispatch(bookQuerySuccess([]));
    Cookies.remove(LEGACY_COOKIE);
    forgetLinkID();
    return null;
  };
}



// WEBPACK FOOTER //
// ./src/actions/bookQuery.js